import React from 'react';

import PriorityMediumIcon from '@atlaskit/icon-priority/glyph/priority-medium';
import PriorityHighestIcon from '@atlaskit/icon-priority/glyph/priority-highest';
import PriorityCriticalIcon from '@atlaskit/icon-priority/glyph/priority-critical';
import { SelectOption } from '../Select/SelectItem';
import { Prioridades } from 'model/solicitacao/PrioridadeSolicitacao';


export class PrioridadesSelectOptions {

  public static readonly NORMAL: SelectOption = { label: Prioridades.NORMAL.nome, value: Prioridades.NORMAL.id, icone: <PriorityMediumIcon label={Prioridades.NORMAL.nome} /> };
  public static readonly ALTA: SelectOption = { label: Prioridades.ALTA.nome, value: Prioridades.ALTA.id, icone: <PriorityHighestIcon label={Prioridades.ALTA.nome} /> };
  public static readonly IMEDIATA: SelectOption = { label: Prioridades.IMEDIATA.nome, value: Prioridades.IMEDIATA.id, icone: <PriorityCriticalIcon label={Prioridades.IMEDIATA.nome} /> };


  public static asArray() {
    return [
      this.NORMAL,
      this.ALTA,
      this.IMEDIATA
    ];
  }

  private static prioridadesById = Object.fromEntries(PrioridadesSelectOptions.asArray().map(x => [x.value, x]));

  public static byId(id: number) {
    return PrioridadesSelectOptions.prioridadesById[id];
  }
}
